import { useContext } from 'react';
import moment from 'moment-timezone';

import Context from 'utils/Context';

function useTimezone(timezone) {
  const { appState, methods } = useContext(Context);

  const { displayLocalTimezone } = appState;
  const setDisplayLocalTimezone = (value) => methods.setAppState({
    displayLocalTimezone: value,
  });

  const localTimezone = moment.tz.guess();

  const sameTimezone = timezone === localTimezone;
  const displayTimezone = displayLocalTimezone ? localTimezone : timezone;

  return {
    displayLocalTimezone,
    sameTimezone,
    displayTimezone,
    localTimezone,
    setDisplayLocalTimezone,
  };
}


export default useTimezone;
